export default "__VITE_ASSET__DK3EjM2A__"